import { BULK_DELETE, TEMPLATES } from "constants/endpoints";
import { get, post, put, deleteApi } from "services/network";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";

export const getTemplates = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    key: obj?.key ? obj.key : "",
    order: obj?.order ? obj.order : "",
  };
  try {
    const result = await get(
      `${TEMPLATES}?page=${params.page}&per=${params.perPage}&query=${params.search}&sort=${params.key}&order=${params.order}`,
      true
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createTemplates = async (data, setErrors = () => {}) => {
  try {
    const result = await post(`${TEMPLATES}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Tempates created successfully"}
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error.response.statusText}
      />
    );
    console.log(error);
  }
};

export const updateTemplates = async (data, id, setErrors = () => {}) => {
  try {
    const result = await put(`${TEMPLATES}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Template updated successfully"}
      />
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
    console.log(error);
  }
};

export const deleteTemplates = async (id) => {
  try {
    const result = await deleteApi(`${TEMPLATES}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Templates deleted successfully"}
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response.statusText}
      />
    );
    console.log(error);
  }
};

export const deleteBulkTemplates = async (data) => {
  try {
    const result = await put(`${TEMPLATES}/${BULK_DELETE}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Template deleted successfully"}
      />
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />
    );
  }
};
